import React, { useState, useRef } from 'react';
import { Box, Button, Flex, Input, List, ListItem } from "@chakra-ui/react";
import { Spinner } from 'react-activity';
import { Link } from 'react-router-dom';
import { FaDownload } from 'react-icons/fa';
import style from "../UploadUserExcel/UploadUserExcel.module.css"
import { getImageBaseUrl } from '../../Helper/env';
import { useBulkOpsJob } from '../../hooks/useBulkOpsJob';

interface companyObject { _id: string; companyName: string }

const IdentifyUsersToAdd: React.FC<{ companyList: companyObject[]; onSuccess?: () => void }> = ({ companyList, onSuccess }) => {
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [selectedCompany, setSelectedCompany] = useState<string | null>(null);
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [showOptions, setShowOptions] = useState<boolean>(false);
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const { isLoading, submit } = useBulkOpsJob('IDENTIFY_ADD', 'Identify_Users_To_Add', onSuccess);

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) setSelectedFile(event.target.files[0]);
    };

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        await submit(selectedFile, selectedCompany);
    };

    const handleInputCompany = (companyId: string, companyName: string) => {
        setSelectedCompany(companyId);
        setSearchTerm(companyName);
        setShowOptions(false);
    };

    const filteredCompanies = companyList?.filter(company =>
        company.companyName.toLowerCase().includes(searchTerm.toLowerCase())
    ) || [];

    return (
        <Box alignItems={"center"}>
            <form className={style.excelForm} onSubmit={handleSubmit} encType="multipart/form-data">
                <Button type="submit" padding={"20px"} width={"200px"} colorScheme="green" isDisabled={isLoading}>
                    {isLoading === false && "Identify Users To Add"}
                    {isLoading && <Spinner speed={0.65} color='green.500' size={2} />}
                </Button>

                <Input
                    ref={fileInputRef}
                    type="file"
                    onChange={handleFileUpload}
                    width={"250px"}
                    accept=".csv"
                />

                <Box position="relative" w={"250px"}>
                    <Input
                        placeholder="Search Partner Company"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onFocus={() => setShowOptions(true)}
                        onBlur={() => setTimeout(() => setShowOptions(false), 200)}
                    />
                    {showOptions && filteredCompanies.length > 0 && (
                        <List
                            position="absolute"
                            top="100%"
                            left={0}
                            right={0}
                            bg="white"
                            border="1px solid"
                            borderColor="gray.200"
                            borderRadius="md"
                            maxH="200px"
                            overflowY="auto"
                            zIndex={10}
                        >
                            {filteredCompanies.map((item) => (
                                <ListItem
                                    key={item._id}
                                    p={2}
                                    cursor="pointer"
                                    _hover={{ bg: "gray.100" }}
                                    onClick={() => handleInputCompany(item._id, item.companyName)}
                                >
                                    {item.companyName}
                                </ListItem>
                            ))}
                        </List>
                    )}
                </Box>

                <Link to={`${getImageBaseUrl()}/azure/api/v1/signedUrl/get-public-document/others/identify_users_to_add_v3.csv`}>
                    <Flex alignItems={"center"} gap={"10px"}>
                        <FaDownload color="green" /> Bulk Identify Template
                    </Flex>
                </Link>
            </form>
        </Box>
    );
};

export default IdentifyUsersToAdd;
